import { IS_STORE_ROOT } from '@/constants';
import {
  PAYMENT_IS_PROCESSING,
  TRIAL_ACTIVATED,
} from '@/constants/notificationMessages';

export const actions = {
  paymentIsProcessingNotification({ commit }) {
    commit(
      'openSnackBar',
      {
        title: PAYMENT_IS_PROCESSING,
        text: 'This could take up to a few minutes',
        dataTest: 'payment_processing_popup',
      },
      IS_STORE_ROOT
    );
  },
  trialActivatingNotification({ commit }) {
    commit(
      'openSnackBar',
      {
        title: TRIAL_ACTIVATED,
        text: 'This may take a moment...',
      },
      IS_STORE_ROOT
    );
  },
};
